import { render, staticRenderFns } from "./registrationCheck.vue?vue&type=template&id=14b0ef34&scoped=true&"
import script from "./registrationCheck.vue?vue&type=script&lang=js&"
export * from "./registrationCheck.vue?vue&type=script&lang=js&"
import style0 from "./registrationCheck.vue?vue&type=style&index=0&id=14b0ef34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b0ef34",
  null
  
)

export default component.exports